(ns app.front.view.admin.commands.data-import-repair
  (:require [ajax.core :refer [POST]]
            [app.admin.data-import-repair :as data-import-repair]
            [app.front.ui :as ui]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.i18n :as i18n]
            [core.front.icons :as i]
            [core.util.util :as util]
            [potpuri.core :as p]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::reset
  (fn [_ _]
    {:comm/command {:command    :admin/get-authority-groups
                    :method     :get
                    :on-success [::customers-response]}}))

(rf/reg-event-db ::customers-response
  (fn [db [_ _ data]]
    (assoc db ::customers data)))

(rf/reg-sub ::customers (p/fn->> ::customers (sort-by :group/name)))

(rf/reg-event-fx ::start-repair
  (fn [_ [_ group-id file language]]
    (POST "/api/command/admin/repair-data-import"
      {:headers       {"Content-Type" "text/csv; charset=utf-8"}
       :url-params    (util/mmap group-id language)
       :body          file
       :handler       (fn [_response]
                        (>evt [:notifications/add :toast :success :success "Started processing the CSV file"]))
       :error-handler (fn [resp]
                        (>evt [:notifications/add :toast :error :failure (or (-> resp :response (get "error"))
                                                                             "Failed to started processing the CSV file")]))})
    {}))

(defn help-text []
  [:<>
   [:section
    [:p "This tool allows you to " [:span.font-bold "add and/or overwrite"] " some data on imported workspaces."]
    [:p "The tool expects a CSV file (UTF-8) with known columns and comma as the separator.
     No trimming is done. Try with a small file first."]
    [:p "It should be safe to process the same file many times. However, some updates may be skipped  in later runs.
    For example, first run may change address source for a workspace from user to GIS causing later runs to skip address update."]
    [:p "Can also set workspace's execution :domain/state and :process/state if the state column matches a known state."]
    [:p "For Application Data updates, one row updates one field. Repeat the permit-number on multiple rows to update
     multiple Application Data fields."]
    [:h5 "Required columns"]
    (into [:ul.mb-4] (map (fn [col] [:li col]) data-import-repair/required-column-names))
    [:h5 "Optional columns"]
    (into [:ul] (map (fn [col] [:li col]) data-import-repair/optional-column-names))]])

(def no-selection "")

(defn controls []
  (r/with-let [*repair-data-file (r/atom nil)
               *authority-group  (r/atom no-selection)
               *language         (r/atom "")]
    (let [tr               (<sub [:tr])
          languages        (<sub [::i18n/locales])
          repair-data-file @*repair-data-file
          authority-group  @*authority-group
          language         @*language]
      [:section
       [:div.bx--row.items-end
        [:div.bx--col-lg-4.mb-2
         (cc/select
           {:id         "data-import-repair-group"
            :value      authority-group
            :class-name "full-width-select"
            :label-text (tr [:customer-id])
            :on-change  (fn [e]
                          (reset! *repair-data-file nil)
                          (reset! *authority-group (futil/tval e)))}
           [ui/placeholder-select-item tr no-selection]
           (for-frag [{:group/keys [id name type]} (<sub [::customers])]
             (cc/select-item {:text  (str name " (" id ", " type ")")
                              :value id})))]
        [:div.bx--col-lg-2.mb-2
         (cc/select
           {:id         "data-import-repair-language"
            :value      language
            :class-name "full-width-select"
            :label-text "Language for parsing address and selecting configuration items"
            :on-change  (fn [e]
                          (reset! *language (->> e futil/tval keyword)))}
           [ui/placeholder-select-item tr ""]
           (for-frag [key (keys languages)]
             (cc/select-item {:text  (str key)
                              :value key})))]
        [:div.bx--col-lg-4.mb-2
         (cc/file-uploader-button {:accept     [".csv"]
                                   :key        (str "data-import-repair-file-" authority-group)
                                   :label-text (tr [:admin/add-file])
                                   :disabled   (= authority-group no-selection)
                                   :on-change  #(reset! *repair-data-file (-> % .-target .-files array-seq first))})]]
       [:div.bx--row.items-end
        [:div.bx--col-lg-4
         [ui/modal-confirmation-button {:tr                  tr
                                        :id                  "data-import-repair-confirmation"
                                        :trigger-button-text "Start repair"
                                        :on-yes-click        (fn [_]
                                                               (>evt [::start-repair authority-group repair-data-file language])
                                                               (reset! *repair-data-file nil)
                                                               (reset! *authority-group no-selection))
                                        :trigger-button-opts {:kind             :danger
                                                              :icon             i/upload
                                                              :icon-description "Start repair"
                                                              :disabled         (or (= authority-group no-selection)
                                                                                    (string? language)
                                                                                    (nil? repair-data-file))}}
          [:div "New data may be added and/or existing data may be overwritten."]]]]])))

(defn view [match]
  [acommon/admin-page
   (util/mmap {:title "Repair imported workspaces"} match)
   [help-text]
   [controls]])

(def route
  {:name        :view/admin.commands.data-import-repair
   :view        view
   :controllers [{:start (fn [] (>evt [::reset]))}]})
